import { Box, BoxProps, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";

interface Props extends BoxProps {
  children: ReactNode;
  title?: string;
}

const ContentBox = ({ children, title, ...other }: Props) => {
  const theme = useTheme();

  return (
    <Box
      {...other}
      sx={{
        px: 2,
        py: 3,
        width: "100%",
        backgroundColor: "white",
        borderRadius: "12px",
        height: "100%",
        border: `1px solid ${theme.palette.grey[200]}`,
        ...other.sx,
      }}
    >
      {title && (
        <Typography
          variant="h5"
          sx={{
            mb: 2,
          }}
        >
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default ContentBox;
